import {PANELMANAGER_SET_PANEL_TITLE} from '../../constants';

export type SetPanelTitleAction = {
    type : typeof PANELMANAGER_SET_PANEL_TITLE;
    panelKey : string;
    title : string;
}

/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {string} title
 *
 * @return {SetPanelTitleAction}
 */
const setPanelTitle = ( panelKey : string, title : string ) : SetPanelTitleAction => {
    return {
        type: PANELMANAGER_SET_PANEL_TITLE,
        panelKey,
        title
    };
}
export type SetPanelTitle = typeof setPanelTitle;

export default setPanelTitle;
